@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.phoneSelectLabel {
  color: v.$palette-white;
  @include t.text(10px, 120%, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.phoneSelectInputWrapper {
  position: relative;
}

.phoneFieldShell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 6px;
  border: 1px solid v.$palette-signal-live;
  background: v.$palette-signal-bg;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:not(.phoneFieldShell--invalid):hover {
    border-color: v.$green-dark-color;
  }

  &:not(.phoneFieldShell--invalid):focus-within {
    outline: none;
    border-color: v.$palette-green-500;
  }
}

.phoneFieldShellDisabled {
  color: v.$palette-gray-700;

  &:not(.phoneFieldShell--invalid):hover,
  &:not(.phoneFieldShell--invalid):focus-within {
    border-color: v.$palette-signal-live;
    box-shadow: none;
  }
}

.phoneFieldShell--invalid {
  border-color: v.$red-light-color;

  &:hover {
    border-color: v.$red-light-color;
  }

  &:focus-within {
    outline: none;
    border-color: v.$red-light-color;
    box-shadow: v.$shadow-focus-red;
  }
}

.phoneFieldShell--embedded {
  min-height: 0;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;

  &:hover {
    border-color: transparent;
  }

  &:focus-within {
    outline: none;
    border: none;
    box-shadow: none;
  }

  &.phoneFieldShell--invalid {
    border-color: transparent;
    box-shadow: none;

    &:hover,
    &:focus-within {
      border-color: transparent;
      box-shadow: none;
    }
  }
}

.phoneFieldDivider {
  flex-shrink: 0;
  width: 1px;
  height: 32px;
  background: v.$palette-gray-500;
}

.phoneFieldInputWrap {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  input::placeholder {
    color: v.$gray-dark-color;
  }
}

.phoneSelectLableWrapper {
  display: flex;
}

.list {
  padding: 4px 8px;
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 6px;
  border: 1px solid v.$palette-signal-live;
  background: v.$palette-signal-bg;
  box-shadow: v.$shadow-dropdown;
  z-index: 4;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");

  &:hover {
    background-color: v.$palette-signal-live;
  }
}

.phoneFieldDividerDisabled {
  background: v.$palette-gray-700;
}